// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_modal__yEgVW {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background-color: rgba(24, 24, 24, 0.8);
  transform: scale(0);
  z-index: 500;
  color: var(--white);
  opacity: 0;
  pointer-events: none;
  transition: 0.3s ease all;
}
.Modal_modalOpened__QLNp0 {
  transform: scale(1);
  opacity: 1;
  pointer-events: all;
  -webkit-backdrop-filter: blur(44px);
          backdrop-filter: blur(44px);
}
.Modal_modalInner__EBJXI {
  width: 100vw;
  height: 100vh;
  min-height: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.Modal_modalTitle1__9YVGp {
  font-size: clamp(30px, 5vw, 70px);
  max-width: 350px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
  position: absolute;
  left: 40px;
  top: 40px;
  margin: -10px 0 0 0;
}
.Modal_modalTitle2__K-AQ\\+ {
  font-size: clamp(30px, 5vw, 70px);
  max-width: 350px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
  position: absolute;
  text-align: right;
  right: 40px;
  bottom: 40px;
  margin: 0 0 -10px 0;
}
.Modal_modalClose__2t\\+lb {
  font-size: clamp(17px, 3vw, 30px);
  position: absolute;
  top: 20px;
  right: 20px;
  color: var(--white20);
  transition: 0.3s ease all;
}
.Modal_modalClose__2t\\+lb:hover {
  color: rgba(255, 255, 255, 0.7);
}
.Modal_modalForm__IGyqG {
  display: flex;
  gap: clamp(12px, 3vw, 32px);
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 450px;
  padding: 20px;
}
.Modal_modalInput__7E-Ol, .Modal_modalTextarea__GWHWG {
  cursor: none;
  text-align: center;
  font-family: Benzin, "sans-serif";
  width: 100% !important;
  padding: clamp(10px, 3vw, 20px);
  font-size: clamp(16px, 3.6vw, 22px);
  color: rgba(255, 255, 255, 0.7);
  border: none;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.05);
  transition: 0.2s ease all;
}
.Modal_modalInput__7E-Ol:focus, .Modal_modalTextarea__GWHWG:focus {
  background-color: rgba(255, 255, 255, 0.1);
}
.Modal_modalInputError__V6gU6 {
  background-color: rgba(255, 114, 114, 0.1);
}
.Modal_modalInputError__V6gU6:focus {
  background-color: rgba(255, 114, 114, 0.15);
}
.Modal_modalButton__af5s8 {
  width: 100%;
  background-color: var(--mainColor);
  font-size: clamp(16px, 3.6vw, 22px);
  color: var(--black);
  border-radius: 5px;
  font-family: Benzin, "sans-serif";
  font-weight: 800;
  border: none;
  padding: clamp(15px, 3vw, 20px);
  cursor: none;
  outline: none;
  box-shadow: none;
  text-transform: uppercase;
  transition: 0.5s ease all;
}
.Modal_modalButton__af5s8:hover {
  background-color: var(--white);
}
.Modal_modalButton__af5s8:active {
  transform: scale(1.05);
  box-shadow: -5px -5px 20px var(--white20);
}

@media (max-height: 800px) {
  .Modal_modalInner__EBJXI {
    gap: 30px;
    min-height: 600px;
    height: auto;
  }
  .Modal_modalClose__2t\\+lb {
    position: static;
    text-align: center;
    padding: 40px 0;
  }
  .Modal_modalTitle1__9YVGp, .Modal_modalTitle2__K-AQ\\+ {
    padding: 0 10px;
    position: static;
    width: 100%;
    text-align: center;
    max-width: none;
    font-size: clamp(25px, 5vw, 70px);
  }
  .Modal_modalTitle1__9YVGp br, .Modal_modalTitle2__K-AQ\\+ br {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EAEA,uCAAA;EACA,mBAAA;EAEA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;AADF;AAEE;EACE,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,mCAAA;UAAA,2BAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAAJ;AAEE;EACE,iCAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;AAAJ;AAEE;EACE,iCAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAAJ;AAEE;EACE,iCAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;AAAJ;AACI;EACE,+BAAA;AACN;AAEE;EACE,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,sBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,yBAAA;AAAJ;AACI;EACE,0CAAA;AACN;AAEE;EACE,0CAAA;AAAJ;AACI;EACE,2CAAA;AACN;AAEE;EACE,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;AAAJ;AACI;EACE,8BAAA;AACN;AACI;EACE,sBAAA;EACA,yCAAA;AACN;;AAIA;EAEI;IACE,SAAA;IACA,iBAAA;IACA,YAAA;EAFJ;EAIE;IACE,gBAAA;IACA,kBAAA;IACA,eAAA;EAFJ;EAIE;IACE,eAAA;IACA,gBAAA;IACA,WAAA;IACA,kBAAA;IACA,eAAA;IACA,iCAAA;EAFJ;EAGI;IACE,aAAA;EADN;AACF","sourcesContent":[".modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: auto;\n  \n  background-color: rgba(#181818, .8);\n  transform: scale(0);\n  \n  z-index: 500;\n  color: var(--white);\n  opacity: 0;\n  pointer-events: none;\n  transition: .3s ease all;\n  &Opened {\n    transform: scale(1);\n    opacity: 1;\n    pointer-events: all;\n    backdrop-filter: blur(44px);\n  }\n  &Inner {\n    width: 100vw;\n    height: 100vh;\n    min-height: 1000px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n  &Title1 {\n    font-size: clamp(30px, 5vw, 70px);\n    max-width: 350px;\n    text-transform: uppercase;\n    color: rgba(#fff, .7);\n    position: absolute;\n    left: 40px;\n    top: 40px;\n    margin: -10px 0 0 0;\n  }\n  &Title2 {\n    font-size: clamp(30px, 5vw, 70px);\n    max-width: 350px;\n    text-transform: uppercase;\n    color: rgba(#fff, .7);\n    position: absolute;\n    text-align: right;\n    right: 40px;\n    bottom: 40px;\n    margin: 0 0 -10px 0;\n  }\n  &Close {\n    font-size: clamp(17px, 3vw, 30px);\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    color: var(--white20);\n    transition: .3s ease all;\n    &:hover {\n      color: rgba(#fff, .7)\n    }\n  }\n  &Form {\n    display: flex;\n    gap: clamp(12px, 3vw, 32px);\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 450px;\n    padding: 20px;\n  }\n  &Input, &Textarea {\n    cursor: none;\n    text-align: center;\n    font-family: Benzin, 'sans-serif';\n    width: 100%!important;\n    padding: clamp(10px, 3vw, 20px);\n    font-size: clamp(16px, 3.6vw, 22px);\n    color: rgba(#fff, .7);\n    border: none;\n    border-radius: 5px;\n    background-color: rgba(#fff, .05);\n    transition: .2s ease all;\n    &:focus {\n      background-color: rgba(#fff, .1);\n    }\n  }\n  &InputError {\n    background-color: rgba(rgb(255, 114, 114), .1);\n    &:focus {\n      background-color: rgba(rgb(255, 114, 114), .15);\n    }\n  }\n  &Button {\n    width: 100%;\n    background-color: var(--mainColor);\n    font-size: clamp(16px, 3.6vw, 22px);\n    color: var(--black);\n    border-radius: 5px;\n    font-family: Benzin, 'sans-serif';\n    font-weight: 800;\n    border: none;\n    padding: clamp(15px, 3vw, 20px);\n    cursor: none;\n    outline: none;\n    box-shadow: none;\n    text-transform: uppercase;\n    transition: .5s ease all;\n    &:hover {\n      background-color: var(--white);\n    }\n    &:active {\n      transform: scale(1.05);\n      box-shadow: -5px -5px 20px var(--white20);\n    }\n  }\n}\n\n@media(max-height: 800px) {\n  .modal {\n    &Inner {\n      gap: 30px;\n      min-height: 600px;\n      height: auto;\n    }\n    &Close {\n      position: static;\n      text-align: center;\n      padding: 40px 0;\n    }\n    &Title1, &Title2 {\n      padding: 0 10px;\n      position: static;\n      width: 100%;\n      text-align: center;\n      max-width: none;\n      font-size: clamp(25px, 5vw, 70px);\n      br {\n        display: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Modal_modal__yEgVW`,
	"modalOpened": `Modal_modalOpened__QLNp0`,
	"modalInner": `Modal_modalInner__EBJXI`,
	"modalTitle1": `Modal_modalTitle1__9YVGp`,
	"modalTitle2": `Modal_modalTitle2__K-AQ+`,
	"modalClose": `Modal_modalClose__2t+lb`,
	"modalForm": `Modal_modalForm__IGyqG`,
	"modalInput": `Modal_modalInput__7E-Ol`,
	"modalTextarea": `Modal_modalTextarea__GWHWG`,
	"modalInputError": `Modal_modalInputError__V6gU6`,
	"modalButton": `Modal_modalButton__af5s8`
};
export default ___CSS_LOADER_EXPORT___;
